<template>
    <div class="">
        <b-container fluid>
            <h1>HRM Role Request Query</h1>

            <b-row>
                <b-col cols="12" lg="4">
                  <BaseSelector v-model="criteria.role"
                    :v="$v.criteria.role"
                    slug="role"
                    label="Role Requested"
                    :options = reqRoles
                  />
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseEmployeeSelector v-model="criteria.person"
                                          label="Person Needing Role"
                                          :v="$v.criteria.person"
                                          slug="person"
                                          tip=""
                                          :showPcn="false"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <b-form-checkbox v-model="criteria.complete" id="complete">
                        <b>Include Complete Requests?</b>
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <hr/>
            <b-row class="mb-3">
              <b-col>
                <b-button type="button" variant="primary" @click="search">
                    <b-spinner small v-show="loading" class="mr-2"></b-spinner>Search</b-button>
                    <b-button type="button" variant="secondary" @click="clear">Clear</b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                  <b-table hover small responsive show-empty
                           :fields="fields"
                           :items="results"
                           :busy="loading">
                      <template #table-caption></template>
                      <template v-slot:cell(actions)="row">
                          <b-button size="sm" @click="manage(row.item)" class="mr-1">
                              manage roles
                          </b-button>
                      </template>
                      <template v-slot:no-data>
                          <p>No requests found.</p>
                      </template>

                      <template v-slot:empty="scope">
                          <p>No requests found.</p>
                      </template>

                      <div slot="table-busy" class="text-center text-danger my-2">
                          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
                          <strong>Loading, Please Wait...</strong>
                      </div>

                  </b-table>
              </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from "axios"
import { commonOptions } from '@/mixins/commonOptions.js'
import BaseSelector from "@/components/BaseSelector";

export default {
  title: 'HRM Role Request Query',
  data: () => ({
    loading: false, 
    loadingDownload: false,

    filter: null,

    criteria: {
      role: null,
      person: null,
      complete: false,
    },
    results: [],
    fields: [
        {key: 'requestedUser.userId', sortable: true, label: 'UserId - Person Requesting Access'},
        {key: 'requestedUser.name', sortable: true, label: 'Name - Person Requesting Access'},
        {key: 'requestedRole', sortable: true, label: 'Role Requested'},
        {key: 'requestDatetime', sortable: true, label: 'Date Request Received'},
        {key: 'submitter.name', sortable: true, label: 'Submitter Name'},
        {key: 'actions', label: 'Actions'},
    ],
  }),
  components: {
      BaseSelector,
  },
  mixins: [
    commonOptions,
  ],
  validations: {
    criteria: {
      role: { required: false },
      person: { required: false },
    }
  },
  created () {
      this.search()
  },
  methods: {
    clear() {
        this.criteria = {
            role: null,
            person: null,
            complete: false
        }
        this.results = []
    },
    search() {
          this.loading = true
          this.results = []
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/roles/search`, this.criteria)
          .then(response => { 
            this.results = response.data
            this.loading = false
          })
    },
    manage(item) {
        this.$router.push({ name: 'manageRole', params: { id: item.id } })
    }
  }
 }
</script>

<style>

</style>